import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../redux/store";
import { UscQuickSpec } from "../../../../../shared-logic/utils/uscUtils";
import { UscDisclaimerType } from "../../../../../shared-logic/types/UscCommonTypes";
import EfficiencyClassSpec from "./EfficiencyClassSpec";
import DisclaimerIconWrapper from "../../common/DisclaimerIconWrapper";
import DocumentExtraSpec from "./DocumentExtraSpec";
import EcolabelExtraSpec from "./EcolabelExtraSpec";
import { uscQuickSpecSelector } from "../../../../utils/specUtils";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import * as Styles from "./HighlightSpecs.styles";
import { Textload } from "../../../../../shared-components/toyota/styles/utils/Skeleton.styles";
import { formatValueUnit } from "../../../../../../common-deprecated/utils/specs";

const HighlightSpecs = (): JSX.Element | null => {
    const specs = useUscSelector(uscQuickSpecSelector("quickSpecs"), shallowEqual);

    if (!specs.length) return null;

    return (
        <Styles.Wrapper role="list">
            {specs.map((spec) => {
                let SpecComponent;

                switch (spec.type) {
                    case UscQuickSpec.Document:
                        SpecComponent = <DocumentExtraSpec spec={spec} />;
                        break;

                    case UscQuickSpec.EfficiencyClass:
                        SpecComponent = <EfficiencyClassSpec spec={spec} />;
                        break;

                    case UscQuickSpec.EcoLabel:
                        SpecComponent = <EcolabelExtraSpec spec={spec} />;
                        break;

                    default:
                        SpecComponent = <>{formatValueUnit(spec.value, spec.unit)}</>;
                        break;
                }

                return (
                    <li key={spec.type}>
                        {spec.loading ? (
                            <Textload width={60} height={20} role="presentation" />
                        ) : (
                            <Styles.SpecWrapper>
                                <Text variant="body-small-book">{spec.title}</Text>

                                <Styles.SpecValueWrapper>
                                    <Text variant="body-small-semibold">{SpecComponent}</Text>

                                    <DisclaimerIconWrapper
                                        type={UscDisclaimerType.Spec}
                                        reference={spec.tooltipReference}
                                    />
                                </Styles.SpecValueWrapper>
                            </Styles.SpecWrapper>
                        )}
                    </li>
                );
            })}
        </Styles.Wrapper>
    );
};

export default HighlightSpecs;
